import React, { Component } from 'react';
import { Table, Tabs } from 'antd';
import jquery from 'jquery';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';
import '../style/home.less';

const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class BonusContent extends Component {
    state = {
        panes: [],
        activeKey: '',
    }

    componentDidMount() {
        const { startDate, endDate } = this.props;
        this.changePanes(startDate, endDate);
    }

    componentWillReceiveProps(nextProps) {
        const { startDate, endDate } = this.props;
        if (startDate !== nextProps.startDate || endDate !== nextProps.endDate) {
            this.changePanes(nextProps.startDate, nextProps.endDate);
        }
    }

    changePanes = (startDate, endDate) => {
        const panes = [];
        let newValue = moment(startDate);
        const endValue = moment(endDate);
        const activeKey = newValue.format(monthFormat);
        while (newValue.valueOf() <= endValue.valueOf()) {
            panes.push({
                title: newValue.format(monthFormat),
                content: null,
            });
            newValue = newValue.add(1, 'M');
        }
        this.setState({
            panes,
            activeKey,
        }, () => {
            this.querySingleCenter();
        })
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.querySingleCenter()
        })
    }

    querySingleCenter = () => {
        const { userId } = this.props;
        const { activeKey } = this.state;
        this.setState({ singleCenterLoading: true });
        const options = {
            method: 'POST',
            url: API_URL.home.queryPerformanceOneSite,
            data: {
                userId,
                date: activeKey,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                this.setState({
                    singleCenterData: datas,
                    singleCenterLoading: false,
                }, () => {
                    const { panes } = this.state;
                    panes.forEach(item => {
                        if (item.title == activeKey) {
                            item.content = this.getSingleCenterTable();
                        } else {
                            item.content = null;
                        }
                    });
                    this.setState({ panes });
                })
            },
            errorResult: () => {
                this.setState({ singleCenterLoading: false });
            }
        };
        $.sendRequest(options);
    }

    getBonusTable = () => {
        const { loading, restDatas: { bonusData = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '考核项',
                dataIndex: 'itemName',
                key: 'itemName',
                render: (text, record) => {
                    if (text.startsWith('合计')) {
                        return <strong>{text}</strong>;
                    }
                    return text;
                }
            }, {
                title: '得分',
                dataIndex: 'score',
                key: 'score',
                width: 370,
                render: (text, record) => {
                    if (record.itemName.startsWith('合计')) {
                        return <strong>{text}</strong>;
                    }
                    return text;
                }
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = bonusData.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getRender = (type, options) => {
        if (type === 'date') {
            return text => text ? text.slice(0, 10) : '';
        } else if (type === 'money') {
            return text => (text && `${text}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
        } else if (type === 'split') {
            // 文本换行
            const { num } = options;
            return (text, record) => {
                const arr  = text ? text.split(',') : [];
                const len = arr.length;
                return (
                    arr.map((item, index) => {
                        if ((index + 1) % num == 0) {
                            return <span>{item}{(len - 1 === index) ? '' : ','}&nbsp;&nbsp;<br /></span>;
                        } else {
                            return `${item}${(len - 1 === index) ? '' : ','}`;
                        }
                    })
                )
            }
        } else if (type === 'toChinese') {
            // 转中文
            const { contrastList } = options;
            return (text, record) => {
                return text ? (contrastList.find(i => i.value === text) || {}).name : '';
            }
        }
    }

    getSingleCenterTable = () => {
        const { singleCenterloading = false, singleCenterData = [] } = this.state;
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 350,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
            }, {
                title: '中心',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 150,
            }, {
                title: '本团队下参与的CRC',
                dataIndex: 'userNames',
                key: 'userNames',
                width: 300,
                render: this.getRender('split', { num: 6 }),
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = singleCenterData.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={singleCenterloading}
                scroll={{y: 300}}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getRequestTable = () => {
        const { loading, restDatas: { remittances = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                fixed: 'left',
                width: 60,
            }, {
                title: '请款单号',
                dataIndex: 'remittanceCode',
                key: 'remittanceCode',
                fixed: 'left',
                width: 100,
            }, {
                title: '请款申请系统时间',
                dataIndex: 'applicationDate',
                key: 'applicationDate',
                fixed: 'left',
                width: 130,
            }, {
                title: 'JDE主项目号',
                dataIndex: 'investigationJdeContractMainCode',
                key: 'investigationJdeContractMainCode',
                fixed: 'left',
                width: 110,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 260,
            }, {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 160,
            }, {
                title: 'JDE项目号',
                dataIndex: 'investigationJdeContractCode',
                key: 'investigationJdeContractCode',
                width: 100,
            }, {
                title: '合同额含税(元)',
                dataIndex: 'jdeContractAmount',
                key: 'jdeContractAmount',
                width: 100,
                render: this.getRender('money'),
            }, {
                title: '关联中心',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 240,
                render: this.getRender('split', { num: 1 }),
            }, {
                title: 'CRC',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 110,
                render: this.getRender('split', { num: 2 }),
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = remittances.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            // 处理表头分组没数据时，不显示滚动条的bug
            setTimeout(() => {
                if (!dataSource.length) {
                    jquery('.leaderRank-rquest .ant-table-scroll .ant-table-header').css('margin-bottom', 0);
                } else {
                    jquery('.leaderRank-rquest .ant-table-scroll .ant-table-header').css('margin-bottom', -16);
                }
            }, 100);
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                scroll={{x: 1370, y: 300}}
                pagination={false}
                columns={getColumns()}
                className="leaderRank-rquest"
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getHandoverTable = () => {
        const { loading, restDatas: { rateMapList = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '月份',
                dataIndex: 'date',
                key: 'date',
                width: 200,
            }, {
                title: '本季度交接人数',
                dataIndex: 'handoverCrcCount',
                key: 'handoverCrcCount',
                width: 300,
            }, {
                title: '本季度在项目中承担CRC工作的人数',
                dataIndex: 'inCrcCount',
                key: 'inCrcCount',
            }, {
                title: '团队交接率',
                dataIndex: 'rate',
                key: 'rate',
                width: 300,
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = rateMapList.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                scroll={{x: 1120, y: 300}}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getNewHospitalTable = () => {
        const { loading, restDatas: { performanceNewlyHospitals = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '成功开发时间',
                dataIndex: 'successfulDevelopmentTime',
                key: 'successfulDevelopmentTime',
                width: 110,
                render: this.getRender('date'),
            }, {
                title: '开发类型',
                dataIndex: 'developmentType',
                key: 'developmentType',
                width: 160,
                render: this.getRender('toChinese', {
                    contrastList: [{
                        value: 'NEW',
                        name: '新医院新科室开发'
                    }, {
                        value: 'EXIST',
                        name: '已有医院新科室开发'
                    }],
                }),
            }, {
                title: '医院名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 200,
            }, {
                title: '科室',
                dataIndex: 'departmentName',
                key: 'departmentName',
                width: 80,
            }, {
                title: '等级',
                dataIndex: 'hospitalLevel',
                key: 'hospitalLevel',
                width: 100,
            }, {
                title: '省',
                dataIndex: 'hospitalProvince',
                key: 'hospitalProvince',
                width: 80,
            }, {
                title: '市',
                dataIndex: 'hospitalCity',
                key: 'hospitalCity',
                width: 80,
            }, {
                title: '详细地址',
                dataIndex: 'hospitalAddress',
                key: 'hospitalAddress',
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = performanceNewlyHospitals.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                scroll={{y: 300}}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getTalentTable = () => {
        const { loading, restDatas: { performanceUserAddPromotions = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 120,
            }, {
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 160,
            }, {
                title: '转岗时间',
                dataIndex: 'promotionTime',
                key: 'promotionTime',
                width: 180,
                render: this.getRender('date'),
            }, {
                title: '转岗前职位',
                dataIndex: 'beforePositionName',
                key: 'beforePositionName',
                width: 210,
            }, {
                title: '转岗后职位',
                dataIndex: 'afterPositionName',
                key: 'afterPositionName',
                width: 210,
            }, {
                title: '转岗后部门',
                dataIndex: 'afterDepartmentName',
                key: 'afterDepartmentName',
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = performanceUserAddPromotions.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                scroll={{y: 300}}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getExcellentCenterTable = () => {
        const { loading, restDatas: { awesomeSiteList = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '签署优选战略合作协议时间',
                dataIndex: 'signTime',
                key: 'signTime',
                width: 500,
                render: this.getRender('date'),
            }, {
                title: '医院名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 500,
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = awesomeSiteList.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                scroll={{y: 300}}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    getOptimaziateCenterTable = () => {
        const { loading, restDatas: { preferenceSiteList = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '津石选为优选时间',
                dataIndex: 'signTime',
                key: 'signTime',
                width: 500,
                render: this.getRender('date'),
            }, {
                title: '医院名称',
                dataIndex: 'hospitalName',
                key: 'hospitalName',
                width: 500,
            }];
            return columns;
        };

        const getDataSource = () => {
            const dataSource = preferenceSiteList.map((item, index) => {
                return {
                    index: index + 1,
                    ...item,
                };
            });
            return dataSource;
        };

        return (
            <Table
                bordered
                loading={loading}
                scroll={{y: 300}}
                pagination={false}
                columns={getColumns()}
                dataSource={getDataSource()}
                rowKey={record => record.index}
            />
        )
    }

    render() {
        const { panes, activeKey } = this.state;
        return (
            <div className="tab-performance">
                <div style={{ lineHeight: '48px' }}>1.加分明细</div>
                {this.getBonusTable()}
                <div style={{ lineHeight: '48px' }}>2.参与的单中心明细</div>
                {
                    panes.length > 1 ?
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {
                                panes.map(pane => <TabPane tab={pane.title} key={pane.title}>{pane.content}</TabPane>)
                            }
                        </Tabs>
                    :
                        this.getSingleCenterTable()
                }
                <div style={{ lineHeight: '48px' }}>3.参与的项目请款明细</div>
                {this.getRequestTable()}
                <div style={{ lineHeight: '48px' }}>4.团队交接率</div>
                {this.getHandoverTable()}
                <div style={{ lineHeight: '48px' }}>5.新的合作医院或科室开发</div>
                {this.getNewHospitalTable()}
                <div style={{ lineHeight: '48px' }}>6.培养人才梯队和输送人才</div>
                {this.getTalentTable()}
                <div style={{ lineHeight: '48px' }}>7.新签署卓越研究中心明细</div>
                {this.getExcellentCenterTable()}
                <div style={{ lineHeight: '48px' }}>8.新优选研究中心(书面)</div>
                {this.getOptimaziateCenterTable()}
            </div>
        );
    }
}

export default BonusContent;


// WEBPACK FOOTER //
// ./src/components/home/leaderPerformanceDetail/BonusContent.js